import React from 'react';

import {
  useFetchArtifactCollectionTriggersQuery,
  useFetchProjectTriggersQuery,
} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';
import {CreateTriggerDrawer} from '../Launch/Triggers/CreateTriggerDrawer/CreateTriggerDrawer';
import {getTriggerDrawerInitForCollection} from '../Launch/Triggers/CreateTriggerDrawer/EventStore';
import {SectionPlaceholder} from './SectionPlaceholder';
import {getTriggerDetails} from './utils';

type CreateTriggerModalProps = {
  open: boolean;
  onClose: () => void;
  projectName: string;
  entityName: string;
  projectID: string;
  artifactCollectionID: string;
  artifactCollectionName: string;
};

export const CreateTriggerDrawerForCollection = ({
  open,
  onClose,
  projectName,
  entityName,
  projectID,
  artifactCollectionID,
  artifactCollectionName,
}: CreateTriggerModalProps) => {
  const projectTriggersQuery = useFetchProjectTriggersQuery({
    variables: {projectName, entityName},
    context: propagateErrorsContext(),
  });
  const collectionTriggersQuery = useFetchArtifactCollectionTriggersQuery({
    variables: {
      artifactCollectionID: artifactCollectionID ?? '',
    },
    skip: !artifactCollectionID,
    context: propagateErrorsContext(),
  });
  const refetchProjectTriggers = projectTriggersQuery.refetch;
  const refetchCollectionTriggers = collectionTriggersQuery.refetch;

  if (projectTriggersQuery.loading || collectionTriggersQuery.loading) {
    return <SectionPlaceholder />;
  }
  const existingAutomations = getTriggerDetails(
    projectTriggersQuery,
    collectionTriggersQuery
  );

  return (
    <CreateTriggerDrawer
      open={open}
      closeDrawer={onClose}
      createTriggerDrawerInit={{
        ...getTriggerDrawerInitForCollection(
          projectID,
          projectName,
          entityName,
          artifactCollectionID,
          artifactCollectionName,
          existingAutomations
        ),
        isUpdating: false,
        trigger: undefined,
      }}
      refetchProjectTriggers={refetchProjectTriggers}
      refetchCollectionTriggers={refetchCollectionTriggers}
    />
  );
};
